import types from "../actionTypes";

export default (
  state = {
    isNotificationPopupShown: false,
    allPendingApplications: [],
    isOnSubmit:false
  },
  action
) => {
  switch (action.type) {
    case types.SET_IS_NOTIFICATION_SHOWN:
      return Object.assign({}, state, {
        isNotificationPopupShown: action.isShown,
      });
    case types.SET_PENDING_APPLICATIONS:
      return Object.assign({}, state, {
        allPendingApplications: action.allPendingApplications,
      });
      case types.SET_ON_SUBMIT:
        return Object.assign({}, state, {
          isOnSubmit: action.isOnSubmit,
        });
    default:
      return state;
  }
};
